/* eslint-disable */
import namespace from './namespace';
import { ApiConfig } from './types';

const env = !namespace ? 'production' : 'development';

const config: ApiConfig = require(`./${env}`).default;
export default config;
